import { getCards } from '@/utils/statScoreApi';
import i18n from '@/utils/i18n.js';

let settingsCards = [
  {
    key: 'standing',
  },
  {
    key: 'participantName',
    start: true,
  },
  {
    key: 'team',
    fill: true,
  },
  {
    key: 'red_cards',
  },
  {
    key: 'yellow_cards',
  },
  {
    key: 'pts',
  },
];

const defaultDataSet = {
  columns: [
    {
      key: 'standing',
      center: true,
      title: '#',
      bordered: true,
    },
    {
      key: 'participantName',
      title: i18n.t('Props.StatScore.Participant Name'),
    },
    {
      key: 'team',
      fill: true,
      title: i18n.t('Props.StatScore.Team'),
    },
    {
      key: 'yellowCard',
      center: true,
      title: '',
    },
    {
      key: 'redCard',
      center: true,
      title: '',
    },
    {
      key: 'info',
      center: true,
      title: '',
    },
  ],
  dataset: [],
  meta: null,
};

const defaultState = {
  cards: { loading: false, data: [] },
  cardStandings: [],
  settingsCards,
};

const state = {
  ...JSON.parse(JSON.stringify(defaultState)),
};

const getters = {};

const mutations = {
  setLoadingStatus(state, data) {
    state.cards = data.status
      ? { loading: data.status, data: [], error: data.error }
      : { ...state.cards, loading: false, error: data.error };
  },
  setDefaultState(state) {
    Object.keys(defaultState).forEach(key => {
      state[key] = defaultState[key];
    });
  },
  setCards(state, data) {
    state.cards.data = data;
  },
  setCardStandings(state, data) {
    state.cardStandings = data;
  },
};

const actions = {
  getCards: ({ commit, rootState }, payload) => {
    commit('setDefaultState');
    commit('setLoadingStatus', { status: true });
    return new Promise((resolve, reject) => {
      return getCards({
        selectedLang: rootState.settings.selectedLocale.short_code,
        id: payload,
      })
        .then(res => {
          commit('setCards', res.data.Data);
          let cardStandings = res.data.Data
            ? res.data.Data.groups.map(item => {
                let teams = item.participants.map(item => {
                  let otherInformations = {};
                  item.columns.forEach(column => {
                    otherInformations = {
                      ...otherInformations,
                      [column.code]: {
                        title: column.name,
                        short_name: column.short_name,
                        data: { ...column },
                      },
                    };
                  });
                  return {
                    ...otherInformations,
                    standing: { short_name: '#', value: item.rank },
                    participantName: {
                      short_name: i18n.t('Props.StatScore.Participant Name'),
                      value: item.name,
                    },
                    team: {
                      short_name: i18n.t('Props.StatScore.Team'),
                      value: item.subparticipant_name,
                    },
                    zone_name: item.zone_name,
                  };
                });
                return {
                  ...item,
                  teams,
                };
              })
            : [];
          commit('setCardStandings', cardStandings);
          commit('setLoadingStatus', { status: false });
          resolve(res);
        })
        .catch(err => {
          console.log(err);
          reject(err);
          commit('setLoadingStatus', { status: false, error: true });
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
